import React from 'react';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import {FieldProps} from "formik";

interface FormValues {
  date: Date | null;
}

interface DatePickerFieldProps extends FieldProps<Date | null> {
  onDateChanged?: (date: Date | null) => void;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({ field, form, onDateChanged }) => {
  const today = new Date();

  // Generate an array of the next 7 days
  const next7Days = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    return date;
  });

  return (
      <DatePicker
          selected={(field.value && new Date(field.value)) || null}
          onChange={(date) => {
            form.setFieldValue(field.name, date);
            if (onDateChanged) {
              onDateChanged(date); // Call the callback with the selected date
            }
          }}
          dateFormat="yyyy/MM/dd"
          minDate={today} // Disable past dates
          excludeDates={next7Days} // Exclude the next 7 days
          placeholderText="Please Select"
          className="block w-full p-4 border-2 border-gray-200 rounded-lg bg-gray-50 text-base focus:border-fred-blue-500 hover:border-fred-blue-500 outline-none disabled:bg-gray-200 disabled:border-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed"
      />
  );
};

export default DatePickerField;
